// extracted by mini-css-extract-plugin
export default {"menu":"header-coorslive_menu__CyO_t","label":"header-coorslive_label__3sdmY"};